/**
 * Forgot Password Route Configuration
 */
(function () {
	'use strict';

	angular
		.module('app')
		.run(appRun);

	appRun.$inject = ['routehelper'];
	function appRun(routehelper) {
		routehelper.configureRoutes(getRoutes());
	}

	function getRoutes() {
		return [
			{
				url: '/forgot',
				config: {
					templateUrl: 'app/forgot/forgot.html',
					controller: 'ForgotController',
					controllerAs: 'vm',
					title: 'Forgot Password'
				}
			}
		];
	}
})();
